import { type FilterChip, FilterChipList } from '@features/allocation';
import { useTranslation } from 'react-i18next';
import type {
  AllocationTagFilterKey,
  AllocationTagFilterState,
} from '../hooks/useAllocationTagFilters';

export function AllocationTagFilterChips({
  filterState,
}: {
  filterState: AllocationTagFilterState;
}) {
  const { t } = useTranslation(['tagsAlocacao', 'alocacao', 'common']);
  const { filters } = filterState;

  const chips: FilterChip<AllocationTagFilterKey>[] = [];
  if (filters.name) {
    chips.push({
      key: 'name',
      text: t('alocacao:filtros.chips.contem', {
        field: t('tagsAlocacao:colunas.nome'),
        value: filters.name,
      }),
    });
  }
  if (filters.color) {
    chips.push({
      key: 'color',
      text: t('alocacao:filtros.chips.contem', {
        field: t('tagsAlocacao:colunas.cor'),
        value: filters.color,
      }),
    });
  }
  if (filters.active !== undefined) {
    chips.push({
      key: 'active',
      text: t('alocacao:filtros.chips.selecionado', {
        field: t('tagsAlocacao:colunas.ativa'),
        name: filters.active ? t('common:yes') : t('common:no'),
      }),
    });
  }

  return (
    <FilterChipList
      chips={chips}
      onRemove={filterState.clearFilter}
      onClear={filterState.clearFilters}
    />
  );
}
